/**
 * Manifest — entry shell.
 *
 * Wraps ManifestProvider once and lets React Router decide between the
 * dashboard (`/manifest`) and the per-contract detail (`/manifest/:id`).
 *
 * This component is mounted by App.js for both routes.
 */
import React from 'react';
import { useParams } from 'react-router-dom';
import { ManifestProvider } from './ManifestContext';
import ManifestDashboard from './ManifestDashboard';
import ManifestDetail from './ManifestDetail';
import './Manifest.css';

const ManifestRouter = () => {
  const { id } = useParams();
  return id ? <ManifestDetail /> : <ManifestDashboard />;
};

const Manifest = () => (
  <ManifestProvider>
    <ManifestRouter />
  </ManifestProvider>
);

export default Manifest;
